import React from 'react';
import { Coins, Gift, Sparkles, TrendingUp } from 'lucide-react';
import { languageService } from '../../js/languageService';

const StakingClaimSection = () => {
  const handleStaking = () => {
    // TODO: Implementar funcionalidad de staking
    console.log('Staking clicked');
  };

  const handleClaim = () => {
    // TODO: Implementar funcionalidad de claim
    console.log('Claim clicked');
  };

  return (
    <section className="py-8 relative">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-96 bg-gradient-to-b from-blue-950/2 to-transparent pointer-events-none"></div>
      <div className="absolute -bottom-20 right-0 w-80 h-80 bg-purple-900/5 rounded-full blur-[100px]"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-6">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4 gradient-heading" data-i18n="staking.title">Staking & Rewards</h2>
          <p className="text-lg sm:text-xl card-text max-w-3xl mx-auto" data-i18n="staking.description">
            Stake your QOKX tokens and earn rewards. Claim your accumulated rewards anytime.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 max-w-4xl mx-auto">
          {/* Staking Card */}
          <div className="glass-card p-6 sm:p-8 hover-glow border border-blue-500/10 relative overflow-hidden">
            {/* Shine effect */}
            <div className="absolute -inset-full h-full w-1/2 z-0 bg-gradient-to-r from-transparent via-white/10 to-transparent skew-x-12 transform -translate-x-full animate-[shine_3s_infinite]"></div>
            
            <div className="relative z-10">
              <div className="flex items-center justify-center mb-6">
                <div className="bg-gradient-to-br from-blue-500 to-purple-600 p-4 rounded-full shadow-lg">
                  <Coins className="w-8 h-8 text-white" />
                </div>
              </div>
              
              <h3 className="text-2xl font-bold text-center mb-4 gradient-heading" data-i18n="staking.staking_title">Staking Pool</h3>
              
              <div className="space-y-4 mb-6">
                <div className="flex justify-between items-center">
                  <span className="card-text" data-i18n="staking.total_staked">Total Staked</span>
                  <span className="text-lg font-semibold card-subtitle">2,450,000 QOKX</span>
                </div>
                
                <div className="flex justify-between items-center">
                  <span className="card-text" data-i18n="staking.your_stake">Your Stake</span>
                  <span className="text-lg font-semibold card-subtitle">0 QOKX</span>
                </div>
              </div>
              
              <button 
                onClick={handleStaking}
                className="w-full gradient-button py-4 px-6 text-white font-medium rounded-full flex items-center justify-center gap-2 hover:shadow-[0_0_20px_rgba(59,130,246,0.4)] transition-all duration-300"
              >
                <TrendingUp className="w-5 h-5" />
                <span data-i18n="staking.stake_now">Stake Now</span>
              </button>
            </div>
          </div>
          
          {/* Claim Card */}
          <div className="glass-card p-6 sm:p-8 hover-glow border border-blue-500/10 relative overflow-hidden">
            {/* Shine effect */}
            <div className="absolute -inset-full h-full w-1/2 z-0 bg-gradient-to-r from-transparent via-white/10 to-transparent skew-x-12 transform -translate-x-full animate-[shine_3s_infinite]" style={{ animationDelay: '1.5s' }}></div>
            
            <div className="relative z-10">
              <div className="flex items-center justify-center mb-6">
                <div className="bg-gradient-to-br from-emerald-500 to-teal-600 p-4 rounded-full shadow-lg">
                  <Gift className="w-8 h-8 text-white" />
                </div>
              </div>
              
              <h3 className="text-2xl font-bold text-center mb-4 gradient-heading" data-i18n="staking.claim_title">Claim Rewards</h3>
              
              <div className="space-y-4 mb-6">
                <div className="flex justify-between items-center">
                  <span className="card-text" data-i18n="staking.available_rewards">Available Rewards</span>
                  <span className="text-2xl font-bold gradient-text">0 QOKX</span>
                </div>
                
                <div className="flex justify-between items-center">
                  <span className="card-text" data-i18n="staking.total_claimed">Total Claimed</span>
                  <span className="text-lg font-semibold card-subtitle">0 QOKX</span>
                </div>                
              </div>
              
              <button 
                onClick={handleClaim}
                className="w-full bg-gradient-to-r from-emerald-500 to-teal-600 py-4 px-6 text-white font-medium rounded-full flex items-center justify-center gap-2 hover:from-emerald-400 hover:to-teal-500 hover:shadow-[0_0_20px_rgba(16,185,129,0.4)] transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={true}
              >
                <Sparkles className="w-5 h-5" />
                <span data-i18n="staking.claim_rewards">Claim Rewards</span>
              </button>
            </div>
          </div>
        </div>
        
        {/* Info Banner */}
        <div className="mt-8 max-w-4xl mx-auto">
          <div className="glass-card p-4 sm:p-6 border border-blue-500/20">
            <div className="flex items-start gap-3">
              <div className="bg-blue-500/10 p-2 rounded-full flex-shrink-0 mt-1">
                <Sparkles className="w-5 h-5 text-blue-500" />
              </div>
              <div>
                <h4 className="font-semibold mb-2 card-subtitle" data-i18n="staking.info_title">How it works</h4>
                <p className="card-text text-sm leading-relaxed" data-i18n="staking.info_description">
                  Stake your QOKX tokens to earn passive income. The longer you stake, the higher your rewards. 
                  Claim your rewards anytime.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StakingClaimSection; 